import React from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import Layout from '../components/layout'
import Nav from '../components/nav'
import SEO from '../components/seo'
import '../styles/index.scss'

import OptBtn from '../components/button'

// Content components
import Integrations from '../components/content/integrations'
import Stories from '../components/stories'

// images
import agent_view from '../images/products/multiagentes/agent_gif.gif'

// channels
import bannerImg from '../images/home/redesign01/banner-home.png'
import u01Img from '../images/home/redesign01/u01.png'
import u02Img from '../images/home/redesign01/u02.png'
import u03Img from '../images/home/redesign01/u03.png'
import u04Img from '../images/home/redesign01/u04.png'
import u05Img from '../images/home/redesign01/u05.png'
import u06Img from '../images/home/redesign01/u06.png'
import mobile from '../images/home/redesign01/mobile.png'

// customers
import customer_aldeas from '../images/home/clients/customer_aldeas.png'
import customer_baristi from '../images/home/clients/customer_baristi.png'
import customer_ccti from '../images/home/clients/customer_ccti.png'
import customer_conoc from '../images/home/clients/customer_conoc.png'
import customer_crucijuegos from '../images/home/clients/customer_crucijuegos.png'
import customer_descuentos from '../images/home/clients/customer_descuentos.png'
import customer_ginza from '../images/home/clients/customer_ginza.png'
import customer_ioimporto from '../images/home/clients/customer_ioimporto.png'
import customer_mcc from '../images/home/clients/customer_mcc.png'
import customer_med from '../images/home/clients/customer_med.png'
import customer_reba from '../images/home/clients/customer_reba.png'
import customer_san_lorenzo from '../images/home/clients/customer_san_lorenzo.png'
import customer_whyline from '../images/home/clients/customer_whyline.png'
import customer_xe_seguridad from '../images/home/clients/customer_xe_seguridad.png'

function Chatbot ({ lang }) {
    const text = {
        es: {
            cs_jobTitle_1: 'CEO en Reba',
            cs_title_1:
                'La mejor plataforma para atención automatizada y centralizada en WhatsApp',
            cs_description_1:
                'Encontramos en Optiwe el partner ideal para mejorar significativamente la experiencia de servicio a nuestros clientes. En solo unos pocos meses pudimos automatizar el 40% de los mensajes/preguntas de nuestros clientes y ofrecer atención personalizada con AI 24x7.',
            cs_jobTitle_2: 'Asesora de Campaña',
            cs_title_2: 'El mejor CRM para WhatsApp',
            cs_description_2:
                'En Optiwe encontramos el partner ideal para escalar nuestro servicio al donante a través de nuestro sitio web y WhatsApp. También, gracias a sus herramientas de outbound, podemos comunicarnos con nuevos potenciales donantes en tiempo real y brindarles la mejor experiencia posible. Estamos muy felices de contar con la tecnología de Optiwe para potenciar a nuestros equipos de atención al donante.',
            page_title:
                'Optiwe - Diseña y crea Chatbot para WhatsApp con una interfaz simple y sin necesidad de escribir código',
            page_description:
                'Diseña y crea chatbots o bots en WhatsApp, Instagram, Facebook y Páginas Web, para automatizar los procesos de ventas y atención de clientes de tu empresa.',
            page_lang: 'es',
            h1_normal:
                'Atiende a tus clientes 24x7 e incrementa tus ventas con Chatbots para WhatsApp',
            h1_description_1:
                'Automatiza las conversaciones con tus clientes utilizando Bot para WhatsApp, Instagram, Facebook y tu página web. Captura la información de nuevos leads, responde preguntas frecuentes, vende tus productos de manera automática y ofrece derivación a agentes para una atención personalizada.',
            demo: 'Agendar demo',
            test: 'Probar gratis',
            customers:
                'Sumate a las empresas que ya usan nuestro CRM WhatsApp Business para hacer crecer sus negocios y mejorar la comunicación con sus clientes',
            h2_benefits: 'Bots y Chatbot para WhatsApp',
            h2_benefits_description:
                'Nuestra solución te permite diseñar el flujo de la conversación con tus clientes de una manera muy simple y sin necesidad de tener ningún conocimiento técnico previo. El Chatbot para WhatsApp incluye habilidades como capturar información de nuevos leads, responder preguntas frecuentes, derivar a agentes de atención y mucho más.',
            h2_benefits_alt:
                'Ejemplo de chatbots en WhatsApp y recomendaciones a agentes de atención',
            h2_productos: 'Chatbots para WhatsApp, Instagram y Facebook',
            h2_prod_1_title: 'Chatbot WhatsApp',
            h2_prod_1_description:
                'Crea múltiples chatbots en todos los canales de comunicación con tus clientes sin ningún tipo de límite: Whatsapp, Facebook, Instagram y sitio web.',
            h2_prod_1_alt: 'Bot para WhatsApp, Instagram y Facebook',
            h2_prod_2_title: 'Generación de leads',
            h2_prod_2_description:
                'Captura información de nuevos leads de manera automática como el nombre, teléfono, email y cualquier otro campo específico que tu negocio necesite.',
            h2_prod_2_alt: 'Generación de leads en WhatsApp',
            h2_prod_3_title: 'Etiquetas automáticas',
            h2_prod_3_description:
                'Utiliza etiquetas para clasificar prospectos y leads de manera automática en función de la conversación que el chatbot tiene con tus clientes.',
            h2_prod_3_alt: 'Etiquetado automático de conversaciones',
            h2_prod_4_title: 'Respuestas a preguntas frecuentes',
            h2_prod_4_description:
                'Responde las preguntas frecuentes de tus clientes utilizando el motor de Inteligencia Artificial de Optiwe. Nuestra solución de Inteligencia Artificial es simple de utilizar y muy intuitiva.',
            h2_prod_4_alt: 'Chatbot y automatización de preguntas frecuentes',
            h2_prod_5_title: 'Diseñador de flujos',
            h2_prod_5_description:
                'Crea flujos de conversaciones, árboles de decisión y menú de opciones con múltiples niveles y emojis, de manera simple con el diseñador de chatbots de Optiwe.',
            h2_prod_5_alt: 'Diseñador de flujos de chatbots',
            h2_prod_6_title: 'Segmentación de conversaciones',
            h2_prod_6_description:
                'Utiliza el Robot WhatsApp para segmentar las conversaciones y derivar al cliente a un agente de atención del sector correcto de tu empresa (por ejemplo puedes segmentar entre Ventas, Soporte, Administración, etc.).',
            h2_prod_6_alt: 'Segmentación de conversaciones por departamento',
            h2_prod_7_title: 'Derivación a agentes de atención',
            h2_prod_7_description:
                'Utiliza el software de atención de Optiwe, para responder las consultas derivadas por el bot. También puedes detener al bot en cualquier momento de la conversación para ofrecer una atención personalizada.',
            h2_prod_7_alt:
                'Derivación de conversaciones entre agentes y grupos de agentes',
            h2_prod_8_title: 'Archivos multimedia',
            h2_prod_8_description:
                'Utiliza el chatbot para compartir imágenes, vídeos y catálogos de tus productos y cualquier otro archivo multimedia que necesites compartir a tus clientes.',
            h2_prod_8_alt: 'Intercambio de archivos multimedia con el chatbot',
            h2_prod_9_title: 'Integración con APIs',
            h2_prod_9_description:
                'Realiza integraciones con otros sistemas ejecutando APIs directamente desde el chatbot en WhatsApp, Instagram, Facebook y tu página web. Automatiza tus flujos de ventas y atención al cliente.',
            h2_prod_9_alt: 'Integración mediante API REST',
            h2_prod_10_title: 'Integración con sistemas externos',
            h2_prod_10_description:
                'Conecta campañas de Facebook, Instagram y WhatsApp con chatbots específicos para cada producto o servicio que estés promocionando. De esta manera, el bot obtiene el contexto del producto que a tu cliente le interesa y puede compartir información relevante.',
            h2_prod_10_alt: 'Derivación de campañas de marketing al Chatbot WhatsApp',
            h2_prod_11_title: 'Reportes y estadísticas',
            h2_prod_11_description:
                'Integra el Chatbot WhatsApp de Optiwe con otros CRMs como Zendesk, Freshdesk, Zoho, HubSpot, entre muchas otras integraciones más.',
            h2_prod_11_alt:
                'Reportes y estadísticas sobre el funcionamiento del Chatbot WhatsApp',
            register: 'Regístrate, es gratis!',
            h2_cs:
                'Las empresas que más venden y mejor atienden a sus clientes ya utilizan Optiwe',
            h2_canales: 'Ventas y soporte omnicanal',
            h2_canales_h3:
                'Comunícate en los canales donde tus clientes te están buscando.',
            h2_canales_description:
                'Utiliza nuestra plataforma de ventas en WhatsApp, Instagram, Facebook, tu sitio web y muchos canales más. Te ayudamos a crear chatbots y reglas de derivación inteligentes a agentes de ventas, para ofrecer la mejor experiencia omnicanal a todos tus clientes!',
            h2_canales_whatsapp_platform: 'Plataforma WhatsApp Business',
            h2_canales_whatsapp_business_api: 'WhatsApp Business API Oficial',
            h2_integrations:
                '¿Qué integraciones ofrece Optiwe para Chatbot WhatsApp?',
            talk: '¡Hablemos!'
        },
        en: {
            cs_jobTitle_1: 'CEO at Reba',
            cs_title_1:
                'The best platform for automated and centralized WhatsApp customer service',
            cs_description_1:
                "We found the ideal partner in Optiwe to significantly improve our customer service experience. In just a few months, we were able to automate 40% of our customers' messages/questions and offer personalized AI support 24x7.",
            cs_jobTitle_2: 'Campaign Advisor',
            cs_title_2: 'The best CRM for WhatsApp',
            cs_description_2:
                "In Optiwe, we found the ideal partner to scale our donor service through our website and WhatsApp. Also, thanks to its outbound tools, we can communicate with new potential donors in real time and provide them with the best possible experience. We are very happy to have Optiwe's technology to empower our donor service teams.",
            page_title:
                'Optiwe - Design and create WhatsApp Chatbot with a simple interfaz and without writing code',
            page_description:
                'Design and create chatbots or bots on WhatsApp, Instagram, Facebook and Web pages to automate the sales and customer service processes of your company.',
            page_lang: 'en',
            h1_normal:
                'Serve your customers 24x7 and increase your sales with chatbots on WhatsApp',
            h1_description_1:
                'Automate conversations with your customers using bots integrated on WhatsApp, Instagram, Facebook, and your website. Capture information about new leads, answer frequently asked questions, automatically sell your products, and offer referrals to agents for personalized support.',
            demo: 'Schedule demo',
            test: 'Try for free',
            customers:
                'Join the companies that already use our WhatsApp Business CRM to grow their businesses and improve communication with their customers',
            h2_benefits: 'Chatbots and Bots for WhatsApp',
            h2_benefits_description:
                'Our solution allows you to design the flow of the conversation with your customers in a very simple way and without the need for any previous technical knowledge. The chatbot includes skills such as capturing information about new leads, answering frequently asked questions, referring to support agents, and much more.',
            h2_benefits_alt:
                'Example of WhatsApp chatbots and recommendations for support agents',
            h2_productos: 'Chatbots for WhatsApp, Instagram, and Facebook',
            h2_prod_1_title: 'Multichannel Chatbots',
            h2_prod_1_description:
                'Create multiple chatbots on all communication channels with your customers without any kind of limit: Whatsapp, Facebook, Instagram, and website.',
            h2_prod_1_alt: 'Chatbots on WhatsApp, Instagram, and Facebook',
            h2_prod_2_title: 'Lead Generation',
            h2_prod_2_description:
                'Automatically capture new lead information such as name, phone, email, and any other specific field your business needs.',
            h2_prod_2_alt: 'Lead generation on WhatsApp',
            h2_prod_3_title: 'Automatic Tags',
            h2_prod_3_description:
                'Use tags to automatically classify prospects and leads based on the conversation the chatbot has with your customers.',
            h2_prod_3_alt: 'Automatic tagging of conversations',
            h2_prod_4_title: 'Frequently Asked Questions (FAQ) Answers',
            h2_prod_4_description:
                "Answer your customers' frequently asked questions using Optiwe's AI engine. Our AI solution is easy to use and very intuitive.",
            h2_prod_4_alt: 'Chatbot and automation of frequently asked questions',
            h2_prod_5_title: 'Flow Designer',
            h2_prod_5_description:
                "Easily create conversation flows, decision trees, and multi-level option menus with emojis using Optiwe's chatbot designer.",
            h2_prod_5_alt: 'Chatbot flow designer',
            h2_prod_6_title: 'Conversation segmentation',
            h2_prod_6_description:
                'Use the bot to segment conversations and direct the customer to the correct department in your company (for example, Sales, Support, Administration, etc.).',
            h2_prod_6_alt: 'Conversation segmentation by department',
            h2_prod_7_title: 'Agent routing',
            h2_prod_7_description:
                "Use Optiwe's support software to respond to queries directed by the bot. You can also stop the bot at any time during the conversation to offer personalized attention.",
            h2_prod_7_alt: 'Conversation routing between agents and agent groups',
            h2_prod_8_title: 'Multimedia files',
            h2_prod_8_description:
                'Use the chatbot to share images, videos, product catalogs, and any other multimedia file you need to share with your customers.',
            h2_prod_8_alt: 'Exchange of multimedia files with the chatbot',
            h2_prod_9_title: 'API integration',
            h2_prod_9_description:
                'Integrate with other systems by running APIs directly from the chatbot on WhatsApp, Instagram, Facebook, and your website. Automate your sales and customer service flows.',
            h2_prod_9_alt: 'Integration through REST API',
            h2_prod_10_title: 'Integration with external systems',
            h2_prod_10_description:
                'Connect Facebook, Instagram, and WhatsApp campaigns with specific chatbots for each product or service you are promoting. This way, the bot obtains context for the product that interests your customer and can share relevant information.',
            h2_prod_10_alt: 'Derivation of marketing campaigns to the chatbot',
            h2_prod_11_title: 'Reports and statistics',
            h2_prod_11_description:
                "Integrate Optiwe's chatbot with other CRMs such as Zendesk, Freshdesk, Zoho, HubSpot, and many more integrations.",
            h2_prod_11_alt: "Reports and statistics on the chatbot's performance",
            register: "Register, it's free!",
            h2_cs:
                'The companies that sell the most and provide the best customer service are already using Optiwe',
            h2_canales: 'Omnichannel sales and support',
            h2_canales_h3:
                'Communicate on the channels where your customers are looking for you.',
            h2_canales_description:
                'Use our sales platform on WhatsApp, Instagram, Facebook, your website, and many more channels. We help you create smart chatbots and routing rules to sales agents, offering the best omnichannel experience to all your customers!',
            h2_canales_whatsapp_platform: 'WhatsApp Business Platform',
            h2_canales_whatsapp_business_api: 'Official WhatsApp Business API',
            h2_integrations: 'What integrations does Optiwe offer?',
            talk: "Let's talk!"
        }
    }

    function renderSignUpButton (buttonText) {
        if (lang === 'en') {
            return (
                <OptBtn isLink rounded small href="/sign-up/">
                    {text[lang][buttonText]}
                </OptBtn>
            )
        }

        if (lang === 'es') {
            return (
                <OptBtn isLink rounded small href="/es/crear-cuenta/">
                    {text[lang][buttonText]}
                </OptBtn>
            )
        }

        throw new Error('Language not supported')
    }

    /*
   ***************
   * SLIDER SETTINGS *
   ***************
   */
    const sliderSettings = {
        dots: true,
        infinite: true,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 1000,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    autoplay: true,
                    speed: 2000,
                    autoplaySpeed: 2000,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    autoplay: true,
                    speed: 2000,
                    autoplaySpeed: 2000,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true
                }
            }
        ]
    }

    /*
   *********************
   * CUSTOMERS STORIES *
   *********************
   */
    const clientStories = [
        {
            id: '1',
            name: 'Stefano Angeli',
            jobTitle: text[lang].cs_jobTitle_1,
            title: text[lang].cs_title_1,
            description: text[lang].cs_description_1,
            img: customer_reba,
            stars: 5
        },
        {
            id: '2',
            name: 'Noelia Nuñez',
            jobTitle: text[lang].cs_jobTitle_2,
            title: text[lang].cs_title_2,
            description: text[lang].cs_description_2,
            img: customer_aldeas,
            stars: 5
        }
    ]

    return (
        <Layout lang={lang}>
            <SEO
                title={text[lang].page_title}
                description={text[lang].page_description}
                lang={text[lang].page_lang}
                locales={[
                    {
                        hreflang: 'en',
                        href: 'https://optiwe.com/products/whatsapp-chatbot/'
                    },
                    {
                        hreflang: 'es',
                        href: 'https://optiwe.com/es/productos/chatbot-whatsapp/'
                    },
                    {
                        hreflang: 'x-default',
                        href: 'https://optiwe.com/products/whatsapp-chatbot/'
                    }
                ]}
            />

            <main className="container-fluid ow-banner">
                {/*
                ^*********
                * HEADER *
                **********
                */}
                <Nav
                    lang={lang}
                    showButtons
                />

                {/*
                ***************
                * MAIN BANNER *
                ***************
                * TODO: If the banner is used in another view, create a <Banner /> component
                */}
                <div className="container ow-banner__content">
                    <div className="row">
                        <div className="col-xl-6 col-xxl-6 ow-banner__home-content">
                            <h1 className="ow-banner__title">{text[lang].h1_normal}</h1>
                            <p className="ow-banner__text">
                                {text[lang].h1_description_1}
                            </p>
                            <div className="row">
                                <div className="col-xl-4 mb-3 mb-md-3">
                                    {
                                        renderSignUpButton('demo')
                                    }
                                </div>
                                <div className="col-xl-4">
                                    {
                                        renderSignUpButton('test')
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-xxl-7 ow-banner__home-image">
                            <img src={bannerImg} alt="optiwe" className="ow-banner__img" />
                        </div>
                    </div>
                </div>
            </main>

            <section
                className="container-fluid ow-section ow-section--features"
                id="features"
            >
                <div className="container success-stories">
                    <div className="row justify-content-center mb-5">
                        <div className="col-md-10">
                            <h2 className="ow-section__title">
                                <span className="bold">{text[lang].customers}</span>
                            </h2>
                        </div>
                        <div className="row">
                            <div className="col-md-10"></div>
                        </div>
                    </div>
                    <div className="mb-5">
                        <Slider {...sliderSettings}>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_aldeas}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_baristi}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_reba}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_ccti}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_conoc}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_crucijuegos}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_descuentos}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_ginza}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_ioimporto}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_mcc}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_med}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_san_lorenzo}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_whyline}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                            <div className="ow-client-wrapper">
                                <img
                                    src={customer_xe_seguridad}
                                    alt="optiwe"
                                    className="ow-features__img"
                                />
                            </div>
                        </Slider>
                    </div>
                </div>
            </section>

            {/*
       ****************
       * Key benefit  *
       ****************
       */}
            <section className="benefits-shapes">
                <svg
                    id="benefits_top_shape"
                    data-name="benefits_top_shape"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMidYMid slice"
                    viewBox="0 0 1920 143.11"
                >
                    <path
                        className="benefits_top_shape"
                        d="M1920,143.11V38.75C1692.68,104.88,1412.86,127.9,1184.41,89,1083.28,71.8,983,44.3,880.43,45.1,705.88,46.4,536.94,129.6,363.09,114c-77.32-7-151.94-33.2-229.26-39.5C89,70.85,41.09,75.79,0,92.94l.22,50.16Z"
                    />
                    <path
                        className="benefits_top_shape"
                        d="M384,72.49c5.25-.88,10.65-1.89,15.23-4.62s8.23-7.75,7.92-13-4.74-9.86-9.87-11.6-10.8-1-15.93.58c-4,1.19-8.2,3-12.06,1.58-4.14-1.57-6.17-6-8.85-9.53C353,25.85,337.1,22.4,327.17,30c-6,4.54-9.81,15.35-7.06,22.55a25.66,25.66,0,0,0,5.42,8c6.64,6.93,17.09,14.23,27,15.22S374,74.25,384,72.49Z"
                    />
                    <path
                        className="benefits_top_shape"
                        d="M443.55,31.61c3.18-3.33,5.56-8.65,2.74-12.32-2.34-3-7.15-3-10.31-.93-1.72,1.09-4.24,3.37-4.92,5.41-1.2,3.23-1.83,9.65,1.81,11.43C436.71,37.19,440.95,34.38,443.55,31.61Z"
                    />
                </svg>
                <div className="container-fluid ow-section--cards" id="benefits">
                    <div className="container">
                        <h2 className="ow-section--cards__title">
                            <span className="bold">{text[lang].h2_benefits}</span>
                        </h2>
                        <p className="ow-section--cards__desc">
                            {text[lang].h2_benefits_description}
                        </p>
                        <img
                            src={agent_view}
                            alt={text[lang].h2_benefits_alt}
                            className="img-responsive"
                        />
                    </div>
                </div>
                <svg
                    id="benefits_bottom_shape"
                    className="benefits_bottom_shape"
                    preserveAspectRatio="xMidYMid slice"
                    viewBox="0 0 1920 143.11"
                    data-name="benefits_bottom_shape"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        className="benefits_bottom_shape"
                        d="M0,0V25.07C100.42,73.33,222.92,85.71,339.3,81.39c156.8-5.8,310.1-35.9,467.5-35.3,150.2.5,300.5,20.5,450.6,13.9,134.5-5.9,267.1-42.9,402.7-27.6,84,9.52,172.75,28.69,259.9,33.2V0Z"
                    />
                </svg>
            </section>

            {/*
       ************
       * FEATURES *
       ************
       */}
            <section
                className="container-fluid ow-section ow-section--features"
                id="features"
            >
                <div className="container features">
                    <div className="row">
                        <div className="col-md-12 features__content">
                            <h2 className="ow-section__title">
                                <span className="bold"></span>
                            </h2>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <h3 className="ow-features__title">
                                {text[lang].h2_prod_1_title}
                            </h3>
                            <p className="ow-features__text">
                                {text[lang].h2_prod_1_description}
                            </p>
                            <img
                                className="ow-features__img"
                                src={u01Img}
                                alt={text[lang].h2_prod_1_alt}
                            />
                        </div>
                        <div className="col-md-6">
                            <h3 className="ow-features__title">
                                {text[lang].h2_prod_2_title}
                            </h3>
                            <p className="ow-features__text">
                                {text[lang].h2_prod_2_description}
                            </p>
                            <img
                                className="ow-features__img"
                                src={u02Img}
                                alt={text[lang].h2_prod_2_alt}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <h3 className="ow-features__title">
                                {text[lang].h2_prod_3_title}
                            </h3>
                            <p className="ow-features__text">
                                {text[lang].h2_prod_3_description}
                            </p>
                            <img
                                className="ow-features__img"
                                src={u04Img}
                                alt={text[lang].h2_prod_3_alt}
                            />
                        </div>
                        <div className="col-md-6">
                            <h3 className="ow-features__title">
                                {text[lang].h2_prod_4_title}
                            </h3>
                            <p className="ow-features__text">
                                {text[lang].h2_prod_4_description}
                            </p>
                            <img
                                className="ow-features__img"
                                src={u03Img}
                                alt={text[lang].h2_prod_4_alt}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <h3 className="ow-features__title">
                                {text[lang].h2_prod_5_title}
                            </h3>
                            <p className="ow-features__text">
                                {text[lang].h2_prod_5_description}
                            </p>
                            <img
                                className="ow-features__img"
                                src={u05Img}
                                alt={text[lang].h2_prod_5_alt}
                            />
                        </div>
                        <div className="col-md-6">
                            <h3 className="ow-features__title">
                                {text[lang].h2_prod_6_title}
                            </h3>
                            <p className="ow-features__text">
                                {text[lang].h2_prod_6_description}
                            </p>
                            <img
                                className="ow-features__img"
                                src={u04Img}
                                alt={text[lang].h2_prod_6_alt}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <h3 className="ow-features__title">
                                {text[lang].h2_prod_7_title}
                            </h3>
                            <p className="ow-features__text">
                                {text[lang].h2_prod_7_description}
                            </p>
                            <img
                                className="ow-features__img"
                                src={u01Img}
                                alt={text[lang].h2_prod_7_alt}
                            />
                        </div>
                        <div className="col-md-6">
                            <h3 className="ow-features__title">
                                {text[lang].h2_prod_8_title}
                            </h3>
                            <p className="ow-features__text">
                                {text[lang].h2_prod_8_description}
                            </p>
                            <img
                                className="ow-features__img"
                                src={u02Img}
                                alt={text[lang].h2_prod_8_alt}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <h3 className="ow-features__title">
                                {text[lang].h2_prod_9_title}
                            </h3>
                            <p className="ow-features__text">
                                {text[lang].h2_prod_9_description}
                            </p>
                            <img
                                className="ow-features__img"
                                src={u05Img}
                                alt={text[lang].h2_prod_9_alt}
                            />
                        </div>
                        <div className="col-md-6">
                            <h3 className="ow-features__title">
                                {text[lang].h2_prod_10_title}
                            </h3>
                            <p className="ow-features__text">
                                {text[lang].h2_prod_10_description}
                            </p>
                            <img
                                className="ow-features__img"
                                src={u06Img}
                                alt={text[lang].h2_prod_10_alt}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <h3 className="ow-features__title">
                                {text[lang].h2_prod_11_title}
                            </h3>
                            <p className="ow-features__text">
                                {text[lang].h2_prod_11_description}
                            </p>
                            <img
                                className="ow-features__img"
                                src={u03Img}
                                alt={text[lang].h2_prod_11_alt}
                            />
                        </div>
                    </div>

                    <div className="features__cta mt-5 mb-5">
                        {
                            renderSignUpButton('register')
                        }
                    </div>
                </div>
            </section>

            {/*
       ************
       * CUSTOMERS *
       ************
       */}
            <section className="clients-shapes">
                <div className="client_top_shape_wrapper">
                    <svg
                        className="svg_top_shape"
                        id="client_top_shape"
                        data-name="client_top_shape"
                        xmlns="http://www.w3.org/2000/svg"
                        preserveAspectRatio="xMidYMid slice"
                        viewBox="0 0 1920 595"
                    >
                        <path
                            className="clients_top_shape"
                            d="M1920,595V0c-89.19,9.65-163.93,79.77-218.34,153.38-59,79.8-107.78,170.9-189.35,227.3-42.59,29.6-92,47.9-142.07,60.9-54.28,14.1-110.67,22.1-166.55,17.3-88.88-7.6-172.16-47.2-260.44-59.5a433,433,0,0,0-255.13,43c-37.89,19.4-72.78,44.3-110.57,63.9C472.28,561,345,571.38,232.24,534.68,151.25,508.33,76.61,458.85,0,420.92V595Z"
                        />
                    </svg>
                </div>
                <div
                    className="container-fluid ow-section ow-section--success-stories"
                    id="success-stories"
                >
                    <div className="container success-stories">
                        <div className="row justify-content-center mb-5">
                            <div className="col-md-10">
                                <h2 className="ow-section__title">
                                    <span className="bold">{text[lang].h2_cs}</span>
                                </h2>
                            </div>
                            <div className="row">
                                <div className="col-md-10"></div>
                            </div>
                        </div>
                        <Stories stories={clientStories} />
                    </div>
                </div>
                <svg
                    id="client_bottom_shape"
                    data-name="client_bottom_shape"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1920 170"
                >
                    <path
                        className="client_bottom_shape"
                        d="M0,0V126.36c143.66,40.06,284.7,51.63,445.48,4.58,236.34-69.2,456.88-50.6,696.62-15.6,149.46,21.9,301.72,27,451.88,8.7,111.21-13.59,217-45.86,326-64.76V0Z"
                    />
                </svg>
            </section>

            {/*
       ************
       * CHANNELS *
       ************
       */}
            <section
                className="container-fluid ow-section ow-section--channels"
                id="channels"
            >
                <div className="container">
                    <div className="row d-flex align-items">
                        <div className="col-md-6 d-flex align-items-center order-1 order-ms-2">
                            <div className="ow-section__content">
                                <h2 className="ow-section__title">
                                    <span className="bold">{text[lang].h2_canales}</span>
                                </h2>
                                <h3 className="ow-section__subtitle">
                                    {text[lang].h2_canales_h3}
                                </h3>
                                <p className="ow-section__text">
                                    {text[lang].h2_canales_description}
                                </p>
                                <div className="row ow-section--channels__btn">
                                    {
                                        renderSignUpButton('test')
                                    }
                                </div>
                                <div className="row ow-section--channels__btn">
                                    <OptBtn
                                        isLink
                                        href="https://business.whatsapp.com/products/business-platform"
                                        rounded
                                        small
                                        className="ws-button"
                                    >
                                        {text[lang].h2_canales_whatsapp_platform}
                                    </OptBtn>
                                </div>
                                <div className="row ow-section--channels__btn">
                                    <OptBtn
                                        isLink
                                        href="https://developers.facebook.com/docs/whatsapp/"
                                        rounded
                                        small
                                        className="ws-button"
                                    >
                                        {text[lang].h2_canales_whatsapp_business_api}
                                    </OptBtn>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 order-2 order-md-1">
                            <img src={mobile} alt="Optiwe" className="img-responsive" />
                        </div>
                    </div>
                </div>
            </section>

            {/*
       ****************
       * INTEGRATIONS *
       ****************
       */}
            <section className="integrations-shapes">
                <svg
                    id="integrations_top_shape"
                    data-name="integrations_top_shape 1"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1920 88"
                >
                    <path
                        className="integrations_top_shape"
                        d="M1920.5,88V43.27C1753,54.14,1581.09,22.09,1411.3,8.49a2363.54,2363.54,0,0,0-388.3,1c-107.6,9.2-212.8,28.4-321.2,34.8-102.5,6.1-195.5,5.9-297.8-3.9C276.5,28.13,126.69,6.36.5,30.37V88Z"
                    />
                </svg>
                <div
                    className="container-fluid ow-section ow-section--clients"
                    id="integrations"
                >
                    <div className="container">
                        <h2 className="ow-section--clients__title">
                            <span className="bold">{text[lang].h2_integrations}</span>
                        </h2>
                        <Integrations />
                    </div>
                </div>
                <svg
                    id="integrations_bottom_shape"
                    data-name="integrations_bottom_shape"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1920 82.17"
                >
                    <path
                        className="integrations_bottom_shape"
                        d="M0,0V25.07C100.42,73.33,222.92,85.71,339.3,81.39c156.8-5.8,310.1-35.9,467.5-35.3,150.2.5,300.5,20.5,450.6,13.9,134.5-5.9,267.1-42.9,402.7-27.6,84,9.52,172.75,28.69,259.9,33.2V0Z"
                    />
                </svg>
            </section>
        </Layout>
    )
}
export default Chatbot
